import { render, staticRenderFns } from "./RankTable.vue?vue&type=template&id=00a86ec4&scoped=true&"
import script from "./RankTable.vue?vue&type=script&lang=js&"
export * from "./RankTable.vue?vue&type=script&lang=js&"
import style0 from "./RankTable.vue?vue&type=style&index=0&id=00a86ec4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a86ec4",
  null
  
)

export default component.exports